import React, { useEffect, useRef, useState } from 'react';
import { Check, ChevronDown, Globe } from 'lucide-react';
import { LANGUAGES, t, useI18n } from '../../i18n';

const LanguageSelector = () => {
  const { language, setLanguage } = useI18n();
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  const current = LANGUAGES.find((item) => item.code === language) || LANGUAGES[0];

  useEffect(() => {
    if (!open) return undefined;
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) setOpen(false);
    };
    const handleEscape = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [open]);

  return (
    <div ref={containerRef} className="relative inline-block">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-haspopup="listbox"
        aria-expanded={open}
        className="flex items-center gap-2 px-4 py-2.5 border border-slate-200 rounded-xl bg-white text-sm font-medium text-slate-700 hover:border-slate-400 focus:ring-2 focus:ring-slate-900/10"
      >
        <Globe className="w-4 h-4 text-slate-500" />
        <span>{current.flag}</span>
        <span>{current.label}</span>
        <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <ul
          role="listbox"
          aria-label={t('Idioma')}
          className="absolute right-0 z-50 mt-2 w-52 bg-white border border-slate-200 rounded-xl shadow-lg py-1"
        >
          {LANGUAGES.map((item) => {
            const selected = item.code === language;
            return (
              <li key={item.code}>
                <button
                  type="button"
                  role="option"
                  aria-selected={selected}
                  onClick={() => {
                    setOpen(false);
                    setLanguage(item.code);
                  }}
                  className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm text-left hover:bg-slate-50 ${
                    selected ? 'font-semibold text-slate-900' : 'text-slate-700'
                  }`}
                >
                  <span>{item.flag}</span>
                  <span className="flex-1">{item.label}</span>
                  {selected && <Check className="w-4 h-4 text-emerald-600" />}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default LanguageSelector;
